module.exports = __webpack_public_path__ + "static/media/Tab_Case_Studies_Inactive.9d7d4783.png";